import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import { services } from '../../services';

export const useGetUpcomingSends = (params, options = {}) => {
  const { code, ...otherParams } = params;

  return useQuery(
    createQueryKey(QUERY_KEYS.useGetUpcomingSendsKey, params),
    () => services.upcomingSends(code, otherParams),
    {
      staleTime: 20 * 1000,
      ...options
    }
  );
};
